// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1US75","sendOtp":"AuthorizeToLogin_sendOtp__3kupZ"};